<template>
    <div class="pt-15 animated fadeIn staticPageInner equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <gofix-default-table :settings="tableConfig" :table-items="tableItems" @new-item="openModalCreate" @load-items="getTableData" @row-click="goToDetail" @delete-items="deleteItems" ref="gofixTable">
                            <template slot="gofix_table:effective_date" slot-scope="row">
                              <span v-if="row.item.active_version && row.item.active_version.effective_date">
                                {{row.item.active_version.effective_date ? row.item.active_version.effective_date : "" | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                              </span>
                              <span v-else>
                                {{row.item.effective_date ? row.item.effective_date : "" | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                              </span>
                            </template>
                          <template slot="gofix_table:description" slot-scope="row">
                            {{row.item.active_version && row.item.active_version.description ? row.item.active_version.description : row.item.description }}
                          </template>
                            <template slot="gofix_table:rate" slot-scope="row">
                              <span v-if="row.item.active_version && row.item.active_version.rate">
                                {{row.item.active_version.rate ? parseFloat(parseFloat((row.item.active_version.rate)*100).toFixed(2)) + '%' : "0%" }}
                              </span>
                              <span v-else>
                                {{row.item.rate ? parseFloat(parseFloat((row.item.rate)*100).toFixed(2)) + '%' : "0%" }}
                              </span>
                            </template>
                        </gofix-default-table>
                    </gofix-card>
                </b-col>
            </b-row>
            <b-modal :no-close-on-backdrop="true" id="modal-Create" @hidden="triggerCloseModal" :title="titleModal" hide-footer :centered="true" ref="modal-Create">
                <b-form class="pb-20">
                    <div class="mb-3">
                        <gofix-button class="mr-3" label="new tax code" @click="selectTax(true)" :outline="!isExists"></gofix-button>
                        <gofix-button label="existing  tax code" @click="selectTax(false)" :outline="isExists"></gofix-button>
                    </div>
                    <gofix-form-input label="Tax Code" v-if="isExists" v-model="tax.tax_code">
                        <template #gofixInput:text:after-desc>
                            <p class="desc color-error" v-if="checkExists">This tax code is already taken</p>
                        </template>
                    </gofix-form-input>
                    <gofix-form-dropdown v-if="!isExists" label="Current Tax code" vLabel="tax_code" :filterable="false" @search="searchTaxCode" v-model="taxSelect" :options="optionsTax">
                    </gofix-form-dropdown>
                    <gofix-form-input label="Description" v-model="tax.description"></gofix-form-input>
                    <b-row>
                        <b-col md="6">
                            <gofix-form-input-number label="Rate [%]" v-model="tax.rate" :integer-limit="3" :include-thousands-separator="false"></gofix-form-input-number>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-date v-model="tax.effective_date" label="Effective Start Date">
                            </gofix-form-input-date>
                        </b-col>
                    </b-row>
                </b-form>
                <b-button-group class="d-block text-right" v-if="$checkRole($accessModule.tax_and_versioning, 'create')">
                    <gofix-button label="SUBMIT" @click="saveTax" noBorder></gofix-button>
                </b-button-group>
            </b-modal>
        </div>
    </div>
</template>
<script>
import { filters } from '@/_filterVar.js';
import moment from 'moment';
export default {
    name: 'reading-log',
    data() {
        return {
            tableConfig: {
                name: 'master-table-tax',
                controls: {
                    create: this.$checkRole(this.$accessModule.tax_and_versioning, 'create'),
                    delete: this.$checkRole(this.$accessModule.tax_and_versioning, 'delete')
                },
                filter: JSON.parse(JSON.stringify(filters['related_tax'])),
                page: 1,
                limit: 100,
                total: 0,
            },
            tableItems: [],
            isAction: false,
            checkExists: false,
            isExists: true,
            selected: [],
            optionsTax: [],
            taxSelect: null,
            loading: {
                listing: false
            },
            tax: {},
            titleModal: "Create a Tax",
        }
    },
    async created() {
        this.loadTax();
    },
    methods: {
        async getTableData(callback) {
            const { tableRequest, resolve, reject } = await callback();
            tableRequest.isList = 1;
            await this.$store.dispatch("TaxVersioningController/getTaxItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load data", "danger");
                    reject();
                })
        },
        async deleteItems(callback) {
            const { ids, filter, resolve, reject } = await callback();
            await this.$store.dispatch('TaxVersioningController/deleteTax', ids)
                .then(response => {
                    this.loadTax();
                    resolve(this.$notificationV2('deleting', 'tax'))
                })
                .catch(err => {
                    reject();
                })
        },
        goToDetail(item) {
            let id = item.id || 0;
            this.$router.push(`${this.$route.path}/${id}`);
        },
        selectTax(e) {
            this.isExists = e
        },
        searchTaxCode(search, loading) {
            this.taxOptions = []
            loading(true);
            if (this.timer) {
                clearTimeout(this.timer);
                this.timer = null;
            }
            this.timer = setTimeout(() => {
                try {
                    this.loadTax({ tax_code: search }, 100);
                    loading(false);
                } catch (err) {
                    loading(false);
                }
            }, 500);
        },
        loadTax(filter = {}, limit = 100) {
            let request = {
                isActive: 1,
                isNotSave: 1,
                limit: limit
            }
            this.$store.dispatch("TaxVersioningController/getTaxItems", request).then(data => {
                this.optionsTax = data.items;
            });
        },
        openModalCreate() {
            this.checkExists = false
            this.titleModal = 'Create Tax';
            this.$refs['modal-Create'].show()
        },
        triggerCloseModal() {
            this.tax = {}
        },
        saveTax() {
            this.isAction = true
            if (!this.tax.rate) {
                return this.$alertNotification("Tax Rate is a required field.", "danger");
            }
            if (this.tax.rate > 100) {
                return this.$alertNotification("Maximum tax rate of 100.", "danger");
            }
            if (!this.tax.effective_date) {
                return this.$alertNotification("Effective Start Date is a required field.", "danger");
            }
            let methob = 'TaxVersioningController/saveTax'
            let param = {
                id: this.tax.id,
                tax_code: this.tax.tax_code,
                description: this.tax.description,
                rate: Number(this.tax.rate),
                effective_date: moment(new Date(this.tax.effective_date)).format('YYYY-MM-DD')
            }
            if (this.isExists) {
                if (!this.tax.tax_code) {
                    return this.$alertNotification("Tax Code is a required field.", "danger");
                }
            } else {
                methob = 'TaxVersioningController/createNewVersion'
                if (!this.taxSelect) {
                    return this.$alertNotification("Current Tax code is a required field.", "danger");
                }
                param.id = this.taxSelect.id
            }
            this.$store.dispatch(methob, param)
                .then(result => {
                    this.$refs.gofixTable.reloadTableKeepFilter();
                    this.loadTax();
                    this.isAction = false;
                    this.$alertNotification(this.$notificationV2('adding', 'tax'));
                    this.$refs["modal-Create"].hide();
                })
                .catch(error => {
                    this.isAction = false;
                    if(error.response) {
                        if (error.response.data.error.message) {
                            this.checkExists = true
                            return this.$alertNotification(error.response.data.error.message, "danger");
                        }
                        this.$alertNotification("Error", "danger");
                    }
                })

        }
    }
}
</script>